import template from "../../../assets/metadata-template.json";
import { ArtMetadataSchema } from "../schedule-presets/art-metadata";
import { ART_HEIGHT, ART_WIDTH } from "../schedule-art/art-canvas";
import { useHistoryStore } from "../../stores/history-store";
import { builderSessionId, useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { useMetadataEditingStore } from "../../stores/metadata-editing-store";
import { useMetadataHistoryStore } from "../../stores/metadata-history-store";
import { defaultElementPosition } from "../schedule-art/layout-coordinates";

function createBuilderTemplate() {
  const metadata = ArtMetadataSchema.parse(structuredClone(template));
  metadata.globals = [{
    bind: "profile.artist_handle", style: "art_creator",
    position: defaultElementPosition([ART_WIDTH / 2, ART_HEIGHT / 2]),
  }];
  metadata.styles.art_creator = { ...metadata.styles.art_creator, size: 48, align: "center" };
  Object.values(metadata.days).forEach((day, index) => {
    day.origin = [Math.round(ART_WIDTH * (index + 1) / 8), 120];
  });
  return metadata;
}

export function openMetadataBuilder() {
  const builder = useMetadataBuilderStore.getState();
  if (builder.active) return;
  const history = useMetadataHistoryStore.getState();
  if (!history.sessions[builderSessionId]) history.initialize(builderSessionId, createBuilderTemplate());
  useHistoryStore.getState().sealMerge();
  const scheduleSelection = useMetadataEditingStore.getState().selected;
  useMetadataBuilderStore.setState({ active: true, scheduleSelection });
  useMetadataEditingStore.getState().select(builder.builderSelection);
}

export function closeMetadataBuilder() {
  const builder = useMetadataBuilderStore.getState();
  if (!builder.active) return;
  useHistoryStore.getState().sealMerge();
  const builderSelection = useMetadataEditingStore.getState().selected;
  useMetadataBuilderStore.setState({ active: false, builderSelection });
  useMetadataEditingStore.getState().select(builder.scheduleSelection);
}
